export default "__VITE_ASSET__3487953d__"